export default "__VITE_ASSET__Bxglh6VD__"